var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeteringIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F9A01B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9494 5.44244C13.0641 5.66293 12.9783 5.93463 12.7578 6.04929L12.4001 6.2353V14.2C12.4001 14.5314 12.1315 14.8 11.8001 14.8H10.4441C10.1956 14.8 9.9941 14.5986 9.9941 14.35V12.25C9.9941 12.0015 9.79263 11.8 9.5441 11.8H8.0501C7.80157 11.8 7.6001 12.0015 7.6001 12.25V14.35C7.6001 14.5986 7.39863 14.8 7.1501 14.8H5.0501C4.80157 14.8 4.6001 14.5986 4.6001 14.35C4.6001 14.1015 4.80157 13.9 5.0501 13.9H5.2001V9.9744C4.99187 10.0483 4.75577 9.95925 4.65094 9.75765C4.53628 9.53715 4.62208 9.26546 4.84258 9.1508L5.2001 8.96489V7.45004C5.2001 7.20151 5.40157 7.00004 5.6501 7.00004C5.89863 7.00004 6.1001 7.20151 6.1001 7.45004V8.49689L12.3426 5.2508C12.5631 5.13614 12.8348 5.22194 12.9494 5.44244Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.517 9.14158C13.6514 9.05999 13.8186 9.05446 13.9581 9.127L15.1577 9.7508C15.3782 9.86546 15.464 10.1372 15.3493 10.3577C15.2445 10.5592 15.0085 10.6482 14.8003 10.5744V13.9H14.9501C15.1986 13.9 15.4001 14.1015 15.4001 14.35C15.4001 14.5986 15.1986 14.8 14.9501 14.8H13.7501C13.6307 14.8 13.5163 14.7526 13.4319 14.6682C13.3475 14.5838 13.3001 14.4694 13.3001 14.35L13.3005 9.52621C13.3005 9.36899 13.3826 9.22317 13.517 9.14158Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeteringIcon);
export default __webpack_public_path__ + "static/media/metering-icon.9ddc9abaf9b5444f73467e1a17a1cae5.svg";
export { ForwardRef as ReactComponent };